import { ReactNode } from "react";

export const BgWrapper = ({
  children,
  className = "",
  onClick = () => {},
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <div
      className={`w-full rounded-2xl bg-white p-3 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
